export const RECOMMENDATION_ACTION = {
  APPROVE: 'approve',
  REVIEW: 'review',
  NO_RECOMMENDATION: 'no_recommendation',
} as const

export type RecommendationAction =
  (typeof RECOMMENDATION_ACTION)[keyof typeof RECOMMENDATION_ACTION]
